import React, { useEffect } from "react"
import styled from "styled-components"
import breakpoints from "../../styles/breakpoints"
import colors from "../../styles/colors"
import fonts from "../../styles/fonts"
import { getIsFrance } from "../../services/locale"

const StyledAlma = styled.div`
  margin: 12px 0 0;
  padding: 0 20px;
  .alma-payment-plans-container {
    ${fonts.openSans};
    width: 100%;
    background: ${(props) => (props.$white ? "transparent" : colors.white)};
    border: ${(props) => (props.$white ? "none" : `1px solid #ccc`)};
    padding: ${(props) => (props.$white ? "0" : "12px")};
  }

  ._2Kqjn {
    ${fonts.openSans};
    font-weight: 400;
    color: ${(props) => (props.$white ? colors.white : "#1A1A1A")} !important;
  }

  .alma-payment-plans-active-option {
    background: ${colors.lightGreen} !important;
    border: none !important;
  }

  ._25GrF {
    ${fonts.openSans};
    color: ${(props) => (props.$white ? colors.white : "#1A1A1A")} !important;
  }

  ._bMClc {
    svg {
      path {
        fill: ${(props) =>
          props.$white ? colors.white : "#1A1A1A"} !important;
      }
    }
  }

  @media (min-width: ${breakpoints.md}) {
    padding: 0 32px;
  }
  @media (min-width: ${breakpoints.lg}) {
    padding: 0;
  }
`

const AlmaWidget = ({ price, white = false }) => {
  useEffect(() => {
    const Alma = window.Alma
    if (Alma) {
      const widgets = Alma.Widgets.initialize(
        "11jYVOH1vqge3MRtc6io0Smo8Wsa13t6j3",
        Alma.ApiMode.LIVE
      )
      const isFrance = getIsFrance()

      widgets.add(Alma.Widgets.PaymentPlans, {
        container: "#alma-widget",
        purchaseAmount: price,
        locale: isFrance ? "fr" : "en",
        hideIfNotEligible: true,
        monochrome: true,
        plans: [
          {
            installmentsCount: 2,
            minAmount: 10000,
            maxAmount: 400000,
          },
          {
            installmentsCount: 3,
            minAmount: 10000,
            maxAmount: 400000,
          },
          {
            installmentsCount: 4,
            minAmount: 10000,
            maxAmount: 400000,
          },
          {
            installmentsCount: 10,
            minAmount: 55000,
            maxAmount: 400000,
          },
        ],
      })
    }
  }, [price])
  return <StyledAlma id="alma-widget" $white={white ? 1 : 0} />
}

export default AlmaWidget
